import { useEffect, useState } from 'react';
import { Email, renderFieldVerticalWrapper } from '@wkda/carlead-creation-components';
import { Trans } from '@lingui/react';
import { i18n as _i18n } from "@lingui/core";
import { AlertBox } from '@wkda/styleguide';
import { useCuriousityDrivenEmailHeader, useTrackElementView } from '../../../hooks';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CarleadEmailFieldWithTracking = ({
  subtitle = false,
  emailInfoMessage
}) => {
  const {
    showCuriousityHeader,
    manufacturer,
    mainType,
    builtDate
  } = useCuriousityDrivenEmailHeader();
  const [emailElement, setEmailElement] = useState(null);
  useEffect(() => {
    setEmailElement(document.getElementById('email'));
  }, []);
  useTrackElementView(emailElement, {
    category: 'lead-form',
    action: 'field-visible',
    leadFieldVisible: 'email',
    method: 'user'
  }, 'lead-form');
  return subtitle ? /*#__PURE__*/_jsx(Email, {
    isHiddenField: true,
    renderFieldWrapper: params => {
      const {
        headerRenderer,
        fieldRenderer,
        belowRenderer,
        name,
        infoText
      } = params;
      return /*#__PURE__*/_jsxs("div", {
        className: "carlead-creation-field",
        children: [headerRenderer({
          label: params.label,
          name
        }), /*#__PURE__*/_jsx("p", {
          className: "carlead-creation-field__email-subtitle",
          children: /*#__PURE__*/_jsx(Trans, {
            id: "carleadCreation.form.emailpage.text",
            components: [/*#__PURE__*/_jsx("strong", {}), /*#__PURE__*/_jsx("br", {})]
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "carlead-creation-field__group",
          children: [fieldRenderer({
            name,
            ...params.extraProps,
            ...params
          }), belowRenderer({
            name,
            text: infoText
          })]
        })]
      });
    }
  }) : /*#__PURE__*/_jsx(Email, {
    isHiddenField: true,
    renderFieldWrapper: renderFieldVerticalWrapper,
    renderHeader: () => /*#__PURE__*/_jsx("label", {
      className: "carlead-creation-field__label",
      htmlFor: "email",
      children: showCuriousityHeader ? /*#__PURE__*/_jsx(Trans, {
        id: "carleadCreation.form.label.email",
        message: "Good news! We are interested in your {manufacturer} {mainType} {builtDate}.<0> Where can we send you your offer?",
        components: [/*#__PURE__*/_jsx("br", {})],
        values: {
          manufacturer,
          mainType: mainType,
          builtDate: builtDate
        }
      }) : _i18n._(
      /*i18n*/
      {
        id: 'carleadCreation.form.label.email'
      })
    }),
    renderInfoText: () => {
      if (!emailInfoMessage) return null;
      return /*#__PURE__*/_jsx("div", {
        className: "mt-1",
        children: /*#__PURE__*/_jsx(AlertBox, {
          className: "alert-box-complete--info",
          children: /*#__PURE__*/_jsx(Trans, {
            id: "carlead.email.invalid.infoText",
            components: [/*#__PURE__*/_jsx("strong", {})]
          })
        })
      });
    }
  });
};